import React from 'react';
import { SectionHeading } from './ui/SectionHeading';
import { Button } from './ui/Button';
import { FadeIn } from './ui/FadeIn';
import { CHECKOUT_URL } from '../lib/config';
export function Cierre() {
  return <section className="bg-gradient-to-br from-mc-gray to-mc-dark border-t-[3px] border-mc-yellow py-[72px] px-5" data-id="element-33">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-34">
        <FadeIn data-id="element-35">
          <SectionHeading centered data-id="element-36">
            Antes de volver al taller,{' '}
            <span className="text-mc-yellow" data-id="element-37">preparate</span>
          </SectionHeading>
          <p className="text-[1.05rem] text-mc-text leading-[1.8] mb-9 mt-5" data-id="element-38">
            No esperes que te vuelvan a cobrar de más. Aprendé a revisar,
            preguntar y decidir. <strong data-id="element-39">Tu bolsillo merece defensa.</strong>
          </p>
          <Button size="large" href={CHECKOUT_URL} data-id="element-40">
            🛡️ Quiero el Pack Taller Blindado
          </Button>
          <p className="mt-4 text-[0.82rem] text-mc-gray3" data-id="element-41">
            Acceso inmediato · Formato digital · $19.999 ARS
          </p>
        </FadeIn>
      </div>
    </section>;
}